import $ from 'jquery';
import Utils from './modules/utils';

let inPageView;
let notInPageView;
let city;
let right;
let left;
let precedingCity;
let nextCity;

function personImageInsteadOfCity() {

    if (city) {
        if ($(window).width() < 640) {
            city.find('.city-image').addClass('person-image');
            city.find('.person-image').css('background-image', 'url(' + right.find('.interviewee-image img').attr('src') + ')');
        } else {
            city.find('.person-image').css('background-image', city.find('.city-image').attr('data-city-image'));
            city.find('.city-image').removeClass('person-image');
        }
    }


}

function openPageView(city_id) {

  if (city) {
    closePageView();
  }

  city = $(city_id);

  precedingCity = city.prev();
  nextCity = city.next();

  right = city.children('.right');
  left = city.children('.left');

  let article = city.find('article');
  let pageViewTitle = city.find('.page-view-title');
  let closeButton = city.find('.close-button');

  let lightFilter = city.find('.light-filter');
  let smallTitle = city.find('.small-title');

  if (precedingCity.length > 0 && Utils.isOdd($('.city').index(city))) {
    precedingCity.addClass('hundred-width');
    precedingCity.find('.left').addClass('hundred-width');
    precedingCity.find('.city-image').addClass('hundred-width');

  } else if (nextCity.length > 0 && Utils.isEven($('.city').index(city))) {
    nextCity.addClass('hundred-width');
    nextCity.find('.left').addClass('hundred-width');
    nextCity.find('.city-image').addClass('hundred-width');
  }

  inPageView = [right, article, pageViewTitle, closeButton];
  notInPageView = [lightFilter, smallTitle];

  Utils.showAllInArr(inPageView);
  Utils.hideAllInArr(notInPageView);

  left.addClass('page-view-open-50');
  right.addClass('page-view-open-50');
  city.addClass('page-view-open-100');

  city.addClass('marginalize');


  city.find('.city-image').attr('data-city-image', city.find('.city-image').css('background-image'));


  personImageInsteadOfCity();



  $('html, body').animate({
      scrollTop: $(city_id).offset().top,
      easing: 'swing'
  }, 500);
}

function closePageView() {
  Utils.hideAllInArr(inPageView);
  Utils.showAllInArr(notInPageView);

  left.removeClass('page-view-open-50');
  right.removeClass('page-view-open-50');
  city.removeClass('page-view-open-100');

  // if ($(window).width() < 640) {
      city.find('.person-image').css('background-image', city.find('.city-image').attr('data-city-image'));
      city.find('.city-image').removeClass('person-image');
  // }



  city.removeClass('marginalize');

  if (precedingCity.length > 0 && Utils.isOdd($('.city').index(city))) {
    precedingCity.removeClass('hundred-width');
    precedingCity.find('.left').removeClass('hundred-width');
    precedingCity.find('.city-image').removeClass('hundred-width');

  } else if (nextCity.length > 0 && Utils.isEven($('.city').index(city))) {
    nextCity.removeClass('hundred-width');
    nextCity.find('.left').removeClass('hundred-width');
    nextCity.find('.city-image').removeClass('hundred-width');
  }
}

$('window').ready(() => {

    if ($(window).width() < 980) {
        $('.cover video').remove();
    }

  $('a').click(function () {
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top,
        easing: 'swing'
    }, 500);
    return false;
  });

  $('.city .city-image').on('click', function () {
    let id = $(this).parent().parent().attr('id');
    window.history.pushState(null, null, '#' + id);
    openPageView('#' + id);
  });

  $('.close-button').on('click', function () {
    window.history.pushState(null, null, ' ');
    closePageView();
  });

  let link = window.location.href;
  if (link.indexOf('#') > -1) {
    let city_id = link.slice(link.indexOf('#'));
    openPageView(city_id);
  }

  $(window).on('resize', function () {
      personImageInsteadOfCity();
  });




});
